export enum EOrderTabsKeys {
	DETAILS = 'details',
	TIMELINE = 'timeline',
}
